module.exports = __webpack_public_path__ + "static/varre3-a6c692ac9748320edd61b83724854dbb.jpg";